import { createApiSlice } from 'app/createApiSlice'
import moment from 'moment-timezone'
import { API_ATTENDANCE_SUMMARY } from 'utils/apiList'

export const attendanceSummaryApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'attendance-summary/api',
  endpoints(builder) {
    return {
      fetchAttendanceSummary: builder.query({
        query({ page, size = 10, sortby, sortdir, from, to, s, memberUserId, notCheckIn }) {
          return {
            url: API_ATTENDANCE_SUMMARY,
            params: {
              search: s,
              page,
              size,
              sortby,
              sortdir,
              from,
              to,
              memberUserId,
              notCheckIn
            },
          }
        },
      }),
    }
  },
})

export const { useFetchAttendanceSummaryQuery } = attendanceSummaryApiSlice
